import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoForPath, SITE_NAME, SITE_URL } from './seoData';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function SeoManager() {
  const { pathname } = useLocation();
  const meta = getSeoForPath(pathname);

  useEffect(() => {
    const canonical = meta.path === '/' ? `${SITE_URL}/` : `${SITE_URL}${meta.path}`;

    document.title = meta.title;

    upsertMeta('name', 'description', meta.description);
    upsertMeta('name', 'keywords', meta.keywords);
    upsertCanonical(canonical);

    upsertMeta('property', 'og:title', meta.title);
    upsertMeta('property', 'og:description', meta.description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:type', meta.path === '/' ? 'website' : 'article');
    upsertMeta('property', 'og:site_name', SITE_NAME);
    if (meta.image) upsertMeta('property', 'og:image', meta.image);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', meta.title);
    upsertMeta('name', 'twitter:description', meta.description);
    if (meta.image) upsertMeta('name', 'twitter:image', meta.image);
  }, [meta]);

  return null;
}